module.exports = __webpack_public_path__ + "static/media/spritesheet.0db81211.svg";